import Heading from '@tiptap/extension-heading';

export default Heading.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                default: null,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
